import { createStore } from './store';

export interface AuthUser {
  id: string;
  email: string;
  username: string | null;
  role: 'PLAYER' | 'ADMIN' | 'KYC_ADMIN';
  emailVerified: boolean;
}

export interface AuthState {
  user: AuthUser | null;
  status: 'idle' | 'authenticating' | 'authenticated' | 'error';
  error: string | null;
}

export const authStore = createStore<AuthState>({
  user: null,
  status: 'idle',
  error: null,
});
